import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import {FormControl, InputLabel, OutlinedInput, Tooltip} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import SvgIcon from "@material-ui/core/SvgIcon";
import InputAdornment from "@material-ui/core/InputAdornment";
import BarcodeScanner from "../components/BarcodeScanner";
import useToken from "../useToken";
import { Redirect } from "react-router-dom";

class ConsultarCodigo extends React.Component{
    constructor(props) {
        super(props);
        this.state ={
            codigo: "",
            open: false,
            scan:false,
        }
    }

    handleClose = () =>{
        this.setState({scan:false})
    }

    getEventType = (event) =>{
        if(event.keyCode === 13){
            if(this.state.codigo){
                this.handleClick()
            }
        }
    }

    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.value});
    }

    handleClick = ()=>{
        this.props.history.push("/detalle_producto/"+ this.state.codigo)
    }

    componentDidMount(){
        document.addEventListener('keyup', this.getEventType, false);
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.getEventType, false);
    }

    recibirTagScan = (codigo)=>{
        this.setState({codigo:codigo, scan:false})
        if(this.state.codigo){
            this.handleClick()
        }
    }

    render() {
        const verifyFolio = useToken.verifyToken()

        if(!verifyFolio){
            return <Redirect to="/inventarios"/>
        }
        else{
            return (
                <div>
                    <Typography variant="h4" gutterBottom>Consultar Código</Typography>
                    <Grid container spacing={1} direction={"row"} justifyContent={"flex-start"} alignItems="center">
                        <Grid item xs={6}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel>Código</InputLabel>
                                <OutlinedInput value={this.state.codigo} name="codigo" onChange={this.handleChange}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <Tooltip title={"Escanear código"}>
                                            <IconButton
                                                onClick={()=>{this.setState({scan:true})}}
                                                style={{backgroundColor:"#3f51b5", color:"#FFFFFF"}} size="small">
                                                <SvgIcon>
                                                    <path fill="currentColor" d="M2,6H4V18H2V6M5,6H6V18H5V6M7,6H10V18H7V6M11,6H12V18H11V6M14,6H16V18H14V6M17,6H20V18H17V6M21,6H22V18H21V6Z" />
                                                </SvgIcon>
                                            </IconButton>
                                        </Tooltip>
                                    </InputAdornment>
                                }
                                labelWidth={50}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={!this.state.codigo}
                                onClick={this.handleClick}>
                                Buscar
                            </Button>
                        </Grid>
                    </Grid>

                    {this.state.scan && <BarcodeScanner recibirTagScan={this.recibirTagScan} handleClose={this.handleClose}/>}

                </div>
            )
        }
    }
}

export default ConsultarCodigo;